import React from 'react'
import { Link } from 'react-router-dom'

const Error403 = () => {
  return (
    <div className='authincation h-100 p-meddle'>
      <div className='container h-100'>
        <div className='row justify-content-center h-100 align-items-center'>
          <div className='col-md-5'>
            <div className='form-input-content text-center error-page'>
              <h1 className='error-text  font-weight-bold'>403</h1>
              <h4>
                <i className='fa fa-times-circle text-danger' /> Accès Refusé!
              </h4>
              <p>Vous n'avez pas le droit d'accès à cette ressource, veuillez consulter votre admistrateur A-Care</p>
              <div>
                <Link className='btn btn-primary' to='/dashboard'>
                  Retourner à l'acceuil
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Error403
